<template>
  <div v-if="project.address" class="contactlist">
    <div class="topsection">
      <div class="logocontainer">
        <div class="logo">
          <button @click="print" class="printbutton">
            <b-icon icon="printer-fill" scale="0.9" />{{ $t('Print') }}
          </button>
          <img :src="managingCompany.logoUrl" />
        </div>
      </div>
      <div class="company-details">
        <span class="companyname">
          {{ managingCompany.companyName }}
        </span>
        <span class="companyname">
          {{ $t('Project Organisation') }}
        </span>
      </div>
    </div>
    <br />
    <br />

    <span class="project-label">
      {{ $t('Project Name') }}
    </span>
    <span class="project-title">
      {{ project.projectNumber }}
      {{ project.title }}
    </span>
    <span class="project-label">
      {{ $t('Project Address') }}
    </span>
    <span class="project-title">
      {{ project.address.street }} / {{ project.address.zipCode }},
      {{ project.address.city }}
    </span>
    <div class="project-management">
      <table>
        <thead>
          <tr>
            <th>{{ $t('Contact Person') }} {{ $t('Project Management') }}</th>
            <th>
              {{ $t('Company') }}
            </th>
            <th>
              {{ $t('Name') }}
            </th>
            <th>
              {{ $t('Phone') }}
            </th>
            <th>
              {{ $t('Email') }}
            </th>
          </tr>
        </thead>
        <thead
          v-for="person in project.projectManagers"
          :key="'pm;' + person.occupation + ';' + person.companyId + ';' + person.personId"
          v-if="shouldShowInList(person)"
        >
          <ViewProjectContactItem :item="person" />
        </thead>
        <tfoot>
          <br /><br />
        </tfoot>
      </table>
    </div>
    <div class="project-subcontractors">
      <table>
        <thead>
          <tr>
            <th>{{ $t('Contact Person') }} {{ $t('Production') }}</th>
            <th>
              {{ $t('Company') }}
            </th>
            <th>
              {{ $t('Name') }}
            </th>
            <th>
              {{ $t('Phone') }}
            </th>
            <th>
              {{ $t('Email') }}
            </th>
          </tr>
        </thead>
        <thead
          v-for="person in project.projectSubcontractors"
          :key="'sc;' + person.occupation + ';' + person.personId"
          v-if="shouldShowInList(person)"
        >
          <ViewProjectContactItem :item="person" />
        </thead>
        <tfoot>
          <br /><br />
        </tfoot>
      </table>
    </div>
    <div class="project-subcontractors">
      <table>
        <thead>
          <tr>
            <th>{{ $t('Contact Person') }} {{ $t('Aftermarket') }}</th>
            <th>
              {{ $t('Company') }}
            </th>
            <th>
              {{ $t('Name') }}
            </th>
            <th>
              {{ $t('Phone') }}
            </th>
            <th>
              {{ $t('Email') }}
            </th>
          </tr>
        </thead>
        <thead
          v-for="person in project.aftermarkets"
          :key="'sc;' + person.occupation + ';' + person.personId"
          v-if="shouldShowInList(person)"
        >
          <ViewProjectContactItem :item="person" />
        </thead>
        <tfoot>
          <br /><br />
        </tfoot>
      </table>
    </div>
    <br /><br />
    <footer>
      {{ managingCompany.companyName }} {{ managingCompany.registrationNumber }} <br />
      {{ managingCompany.address.street }}, {{ managingCompany.address.zipCode }} {{ managingCompany.address.city }}
      <br />
      {{ managingCompany.url }} <br />
      {{ managingCompany.email }} <br />
    </footer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ViewProjectContactItem from './ViewProjectContactItem';

export default {
  name: 'ViewProjectContacts',
  data() {
    return {
      project: {},
    };
  },
  methods: {
    ...mapActions(['loadProject']),
    shouldShowInList: function (item) {
      return item && item.occupation && (item.companyId || item.personId);
    },
    print: function () {
      window.print();
    },
  },
  computed: {
    ...mapGetters(['managingCompany']),
  },
  components: {
    ViewProjectContactItem,
  },
  mounted: async function () {
    if (this.$route.params._id) {
      this.project = await this.loadProject(this.$route.params._id);
    }
  },
  watch: {
    $route: async function (to, from) {
      console.log('EditProject::watch:', JSON.stringify(from), JSON.stringify(to));
      if (this.$route.params._id) {
        if (this.$route.params._id !== this.project._id) {
          this.project = await this.loadProject(this.$route.params._id);
        }
      }
    },
  },
};
</script>

<style scoped>
.topsection {
  position: relative;
}
.topsection button {
  color: black;
}
.logocontainer {
  position: absolute;
  right: 0px;
  text-align: center;
}

.logo img {
  max-width: 3cm;
  max-height: 3cm;
  right: 3mm;
}

.contactlist {
  background-color: white;
  color: black;
  position: relative;
  padding: 2cm;
  font-size: 70%;
}
.companyname {
  text-transform: uppercase;
  display: block;
}

table {
  width: 100%;
  border-spacing: 0px;
  border-collapse: collapse;
}

th {
  padding-top: 10mm;
  text-align: left;
  border-bottom: 3px solid black;
}

.project-label {
  font-size: 80%;
  text-transform: uppercase;
}

.project-title {
  display: block;
  font-size: 120%;
}

.project-management {
  width: 100%;
  position: relative;
}

.project-subcontractors {
  width: 100%;
  position: relative;
  page-break-inside: avoid;
}

.printbutton {
  position: relative;
  top: -62px;
  left: 66px;
}

footer {
  display: block;
  width: 100%;
}

@media print {
  footer {
    position: absolute;
    bottom: 0mm;
  }

  .contactlist {
    padding: 2cm;
  }

  .printbutton {
    display: none;
  }

  @page {
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/project/ViewProjectContacts.vue